const countries = require('i18n-iso-countries');

module.exports = function(value) {
  return countries.getName(value, 'en');
};
